import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrdersState = () => React.useContext(Context)
export const useServiceOrders = () => useServiceOrdersState()?.serviceOrders

const QUERY = gql`
  query ServiceOrders($ids: [Integer]) {
    serviceOrders(filter: { ids: $ids, ignoreSegments: true }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      scheduling
      description
      resumeToken
      address {
        search
        complement
      }
      documents {
        id
        src
        type
      }
      status {
        id
        name
      }
      priority {
        id
        name
      }
      user {
        id
        name
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
      }
      asset {
        id
        name
        placeId
      }
      checklist {
        id
        name
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children }) => {
  const { ids } = useModalData()

  const { data, ...state } = useQuery(QUERY, {
    skip: !ids?.length,
    variables: { ids },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
